import { IApplicationState } from '../../types/redux';

export const getMarkedList = (state: IApplicationState) => state.developerV2?.seo?.markedList || [];
